import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "d-flex flex-column gap-4" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex justify-content-end mb-4"
}
const _hoisted_3 = { class: "svg-icon svg-icon-3" }
const _hoisted_4 = {
  key: 1,
  class: "d-flex justify-content-between mb-4"
}
const _hoisted_5 = { class: "svg-icon svg-icon-2 svg-icon-gray-600" }
const _hoisted_6 = { class: "d-flex gap-2" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "svg-icon svg-icon-2 svg-icon-gray-600" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1)
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "svg-icon svg-icon-3 me-2 ms-0" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1)
const _hoisted_13 = { class: "d-flex flex-column gap-7 gap-lg-10" }
const _hoisted_14 = {
  key: 0,
  class: "card"
}
const _hoisted_15 = { class: "card-body" }
const _hoisted_16 = { class: "d-flex flex-wrap flex-sm-nowrap" }
const _hoisted_17 = { class: "me-7 mb-4" }
const _hoisted_18 = { class: "symbol symbol-70px symbol-fixed position-relative w-70px h-70px d-flex justify-content-center align-items-start overflow-hidden" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("img", {
  class: "w-100 h-auto",
  src: "media/svg/custom/individual.svg"
}, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("img", {
  class: "w-100 h-auto",
  src: "media/svg/custom/company.svg"
}, null, -1)
const _hoisted_21 = { class: "flex-grow-1 h-70px" }
const _hoisted_22 = { class: "d-flex justify-content-between align-items-start flex-wrap h-100" }
const _hoisted_23 = { class: "d-flex flex-column h-100 justify-content-between" }
const _hoisted_24 = { class: "d-flex align-items-center" }
const _hoisted_25 = { class: "text-gray-800 fs-1 fw-bold lh-1 me-2" }
const _hoisted_26 = { class: "d-flex flex-wrap fw-bold text-gray-400 mb-2 pe-2" }
const _hoisted_27 = {
  key: 0,
  class: "d-flex flex-wrap flex-stack mt-3"
}
const _hoisted_28 = { class: "d-flex flex-column flex-grow-1 pe-8" }
const _hoisted_29 = { class: "d-flex flex-wrap" }
const _hoisted_30 = {
  key: 0,
  class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3"
}
const _hoisted_31 = { class: "d-flex align-items-center" }
const _hoisted_32 = { class: "fs-2 fw-bolder" }
const _hoisted_33 = { class: "fw-bold fs-6 text-gray-400" }
const _hoisted_34 = {
  key: 1,
  class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3"
}
const _hoisted_35 = { class: "d-flex align-items-center" }
const _hoisted_36 = { class: "fs-2 fw-bolder" }
const _hoisted_37 = { class: "fw-bold fs-6 text-gray-400" }
const _hoisted_38 = {
  key: 0,
  class: "d-flex flex-wrap flex-stack mt-3"
}
const _hoisted_39 = { class: "d-flex flex-column flex-grow-1 pe-8" }
const _hoisted_40 = { class: "d-flex flex-wrap" }
const _hoisted_41 = {
  key: 0,
  class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3"
}
const _hoisted_42 = { class: "d-flex align-items-center" }
const _hoisted_43 = { class: "fs-2 fw-bolder" }
const _hoisted_44 = { class: "fw-bold fs-6 text-gray-400" }
const _hoisted_45 = {
  key: 1,
  class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3"
}
const _hoisted_46 = { class: "d-flex align-items-center" }
const _hoisted_47 = { class: "fs-2 fw-bolder" }
const _hoisted_48 = { class: "fw-bold fs-6 text-gray-400" }
const _hoisted_49 = {
  key: 2,
  class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3"
}
const _hoisted_50 = { class: "d-flex align-items-center" }
const _hoisted_51 = { class: "fs-2 fw-bolder" }
const _hoisted_52 = { class: "fw-bold fs-6 text-gray-400" }
const _hoisted_53 = {
  key: 1,
  class: "card"
}
const _hoisted_54 = { class: "card-body p-9" }
const _hoisted_55 = { class: "row" }
const _hoisted_56 = { class: "col-md-6" }
const _hoisted_57 = { class: "form-group mb-7" }
const _hoisted_58 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_59 = { class: "col-md-6" }
const _hoisted_60 = { class: "form-group mb-7" }
const _hoisted_61 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_62 = { class: "col-md-6" }
const _hoisted_63 = { class: "form-group mb-7" }
const _hoisted_64 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "form-group mb-7" })
], -1)
const _hoisted_66 = { class: "col-md-6" }
const _hoisted_67 = { class: "form-group mb-7" }
const _hoisted_68 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_69 = { class: "w-100 d-flex justify-content-end el-input el-input-group el-input-group--prepend el-input--suffix" }
const _hoisted_70 = { class: "el-input-group__prepend d-flex w-auto flex-center px-0" }
const _hoisted_71 = { class: "col-md-6" }
const _hoisted_72 = { class: "form-group mb-7" }
const _hoisted_73 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_74 = { class: "col-md-6" }
const _hoisted_75 = { class: "form-group mb-7" }
const _hoisted_76 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_77 = { class: "col-md-6" }
const _hoisted_78 = { class: "form-group mb-7" }
const _hoisted_79 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_80 = { class: "col-md-6" }
const _hoisted_81 = { class: "form-group mb-7" }
const _hoisted_82 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_83 = { class: "card" }
const _hoisted_84 = { class: "card-header py-5" }
const _hoisted_85 = { class: "card-title align-items-start flex-column" }
const _hoisted_86 = { class: "card-body p-9" }
const _hoisted_87 = {
  key: 0,
  class: "row"
}
const _hoisted_88 = { class: "col-md-6" }
const _hoisted_89 = { class: "form-group d-flex flex-column flex-wrap" }
const _hoisted_90 = { class: "col-lg-4 fw-bold text-muted" }
const _hoisted_91 = { class: "col-lg-8" }
const _hoisted_92 = { class: "fw-bold fs-6 text-dark" }
const _hoisted_93 = { class: "col-md-6" }
const _hoisted_94 = { class: "form-group d-flex flex-column flex-wrap" }
const _hoisted_95 = { class: "col-lg-4 fw-bold text-muted" }
const _hoisted_96 = { class: "col-lg-8" }
const _hoisted_97 = { class: "fw-bold fs-6 text-dark" }
const _hoisted_98 = { class: "col-md-6" }
const _hoisted_99 = { class: "form-group d-flex flex-column flex-wrap" }
const _hoisted_100 = { class: "col-lg-4 fw-bold text-muted" }
const _hoisted_101 = { class: "col-lg-8" }
const _hoisted_102 = { class: "fw-bold fs-6 text-dark" }
const _hoisted_103 = { class: "col-md-6" }
const _hoisted_104 = { class: "form-group d-flex flex-column flex-wrap" }
const _hoisted_105 = { class: "col-lg-4 fw-bold text-muted" }
const _hoisted_106 = { class: "col-lg-8" }
const _hoisted_107 = { class: "fw-bold fs-6 text-dark" }
const _hoisted_108 = { class: "col-md-6" }
const _hoisted_109 = { class: "form-group d-flex flex-column flex-wrap" }
const _hoisted_110 = { class: "col-lg-4 fw-bold text-muted" }
const _hoisted_111 = { class: "col-lg-8" }
const _hoisted_112 = { class: "fw-bold fs-6 text-dark" }
const _hoisted_113 = { class: "col-md-12" }
const _hoisted_114 = { class: "form-group d-flex flex-column flex-wrap" }
const _hoisted_115 = { class: "col-lg-4 fw-bold text-muted" }
const _hoisted_116 = { class: "col-lg-8" }
const _hoisted_117 = { class: "fw-bold fs-6 text-dark" }
const _hoisted_118 = {
  key: 1,
  class: "row"
}
const _hoisted_119 = { class: "col-md-6" }
const _hoisted_120 = { class: "form-group mb-7" }
const _hoisted_121 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_122 = { class: "col-md-6" }
const _hoisted_123 = { class: "form-group mb-7" }
const _hoisted_124 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_125 = { class: "col-md-6" }
const _hoisted_126 = { class: "form-group mb-7" }
const _hoisted_127 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_128 = { class: "col-md-6" }
const _hoisted_129 = { class: "form-group mb-7" }
const _hoisted_130 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_131 = { class: "col-md-6" }
const _hoisted_132 = { class: "form-group mb-7" }
const _hoisted_133 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_134 = { class: "col-md-12" }
const _hoisted_135 = { class: "form-group mb-7" }
const _hoisted_136 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_137 = { class: "card" }
const _hoisted_138 = { class: "card-header py-5" }
const _hoisted_139 = { class: "card-title align-items-start flex-column" }
const _hoisted_140 = { class: "card-body p-9" }
const _hoisted_141 = {
  key: 0,
  class: "row"
}
const _hoisted_142 = { class: "col-md-12" }
const _hoisted_143 = { class: "form-group d-flex flex-column flex-wrap" }
const _hoisted_144 = { class: "col-lg-4 fw-bold text-muted" }
const _hoisted_145 = { class: "col-lg-8" }
const _hoisted_146 = { class: "fw-bold fs-6 text-dark" }
const _hoisted_147 = { class: "col-md-6" }
const _hoisted_148 = { class: "form-group d-flex flex-column flex-wrap" }
const _hoisted_149 = { class: "col-lg-4 fw-bold text-muted" }
const _hoisted_150 = { class: "col-lg-8" }
const _hoisted_151 = { class: "fw-bold fs-6 text-dark" }
const _hoisted_152 = { class: "col-md-6" }
const _hoisted_153 = { class: "form-group d-flex flex-column flex-wrap" }
const _hoisted_154 = { class: "col-lg-4 fw-bold text-muted" }
const _hoisted_155 = { class: "col-lg-8" }
const _hoisted_156 = { class: "fw-bold fs-6 text-dark" }
const _hoisted_157 = { class: "col-md-6" }
const _hoisted_158 = { class: "form-group d-flex flex-column flex-wrap" }
const _hoisted_159 = { class: "col-lg-4 fw-bold text-muted" }
const _hoisted_160 = { class: "col-lg-8" }
const _hoisted_161 = { class: "fw-bold fs-6 text-dark" }
const _hoisted_162 = { class: "col-md-6" }
const _hoisted_163 = { class: "form-group d-flex flex-column flex-wrap" }
const _hoisted_164 = { class: "col-lg-4 fw-bold text-muted" }
const _hoisted_165 = { class: "col-lg-8" }
const _hoisted_166 = { class: "fw-bold fs-6 text-dark" }
const _hoisted_167 = {
  key: 1,
  class: "row"
}
const _hoisted_168 = { class: "col-md-6" }
const _hoisted_169 = { class: "form-group mb-7" }
const _hoisted_170 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_171 = { class: "col-md-6" }
const _hoisted_172 = { class: "form-group mb-7" }
const _hoisted_173 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_174 = { class: "col-md-6" }
const _hoisted_175 = { class: "form-group mb-7" }
const _hoisted_176 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_177 = { class: "col-md-6" }
const _hoisted_178 = { class: "form-group mb-7" }
const _hoisted_179 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_180 = { class: "col-md-6" }
const _hoisted_181 = { class: "form-group mb-7" }
const _hoisted_182 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_183 = { class: "card" }
const _hoisted_184 = { class: "card-header py-5" }
const _hoisted_185 = { class: "card-title align-items-start flex-column" }
const _hoisted_186 = { class: "card-body p-9" }
const _hoisted_187 = {
  key: 0,
  class: "row"
}
const _hoisted_188 = { class: "col-md-12" }
const _hoisted_189 = { class: "form-group d-flex flex-column flex-wrap" }
const _hoisted_190 = { class: "col-lg-4 fw-bold text-muted" }
const _hoisted_191 = { class: "col-lg-8" }
const _hoisted_192 = { class: "fw-bold fs-6 text-dark" }
const _hoisted_193 = {
  key: 1,
  class: "row"
}
const _hoisted_194 = { class: "col-md-6" }
const _hoisted_195 = { class: "form-group mb-7" }
const _hoisted_196 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_197 = {
  key: 2,
  class: "card"
}
const _hoisted_198 = { class: "card-header py-5" }
const _hoisted_199 = { class: "card-title align-items-start flex-column" }
const _hoisted_200 = { class: "card-body p-9" }
const _hoisted_201 = { class: "row" }
const _hoisted_202 = { class: "col-md-6" }
const _hoisted_203 = { class: "form-group d-flex flex-column flex-wrap" }
const _hoisted_204 = { class: "col-lg-4 fw-bold text-muted" }
const _hoisted_205 = { class: "col-lg-8" }
const _hoisted_206 = { class: "fw-bold fs-6 text-dark" }
const _hoisted_207 = { class: "col-md-6" }
const _hoisted_208 = { class: "form-group d-flex flex-column flex-wrap" }
const _hoisted_209 = { class: "col-lg-4 fw-bold text-muted" }
const _hoisted_210 = { class: "col-lg-8" }
const _hoisted_211 = { class: "fw-bold fs-6 text-dark" }
const _hoisted_212 = { class: "col-md-6" }
const _hoisted_213 = { class: "form-group d-flex flex-column flex-wrap" }
const _hoisted_214 = { class: "col-lg-4 fw-bold text-muted" }
const _hoisted_215 = { class: "col-lg-8" }
const _hoisted_216 = { class: "fw-bold fs-6 text-dark" }
const _hoisted_217 = { class: "col-md-6" }
const _hoisted_218 = { class: "form-group d-flex flex-column flex-wrap" }
const _hoisted_219 = { class: "col-lg-4 fw-bold text-muted" }
const _hoisted_220 = { class: "col-lg-8" }
const _hoisted_221 = { class: "fw-bold fs-6 text-dark" }
const _hoisted_222 = {
  key: 2,
  class: "d-flex justify-content-between mt-4"
}
const _hoisted_223 = { class: "svg-icon svg-icon-2 svg-icon-gray-600" }
const _hoisted_224 = { class: "d-flex gap-2" }
const _hoisted_225 = ["disabled"]
const _hoisted_226 = { class: "svg-icon svg-icon-2 svg-icon-gray-600" }
const _hoisted_227 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1)
const _hoisted_228 = ["disabled"]
const _hoisted_229 = { class: "svg-icon svg-icon-3 me-2 ms-0" }
const _hoisted_230 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_TemplateType = _resolveComponent("TemplateType")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_auth = _resolveDirective("auth")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref: "formRef",
      model: _ctx.formData,
      rules: _ctx.rules
    }, {
      default: _withCtx(() => [
        (_ctx.type === 0)
          ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
              _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                class: "btn btn-primary",
                replace: "",
                to: _ctx.goPath(0)
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, [
                    _createElementVNode("span", _hoisted_3, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
                    ]),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("common.edit")), 1)
                  ])
                ]),
                _: 1
              }, 8, ["to"])), [
                [_directive_auth, { auth: ['update'] }]
              ])
            ])), [
              [_directive_auth, { auth: ['view'] }]
            ])
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_router_link, {
                class: "btn bg-secondary align-self-center text-gray-600",
                replace: "",
                to: _ctx.goPath(1)
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_5, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr063.svg" })
                  ]),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("settlementEntity.return")), 1)
                ]),
                _: 1
              }, 8, ["to"]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn bg-secondary align-self-center text-gray-600",
                  disabled: _ctx.loading,
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.getShowInfo && _ctx.getShowInfo(...args)))
                }, [
                  _withDirectives(_createElementVNode("span", null, [
                    _createElementVNode("span", _hoisted_8, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr059.svg" })
                    ]),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("common.reset")), 1)
                  ], 512), [
                    [_vShow, !_ctx.loading]
                  ]),
                  _withDirectives(_createElementVNode("span", null, [
                    _hoisted_9,
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("common.pleaseWait")), 1)
                  ], 512), [
                    [_vShow, _ctx.loading]
                  ])
                ], 8, _hoisted_7),
                _withDirectives((_openBlock(), _createElementBlock("button", {
                  type: "button",
                  class: "btn btn-primary",
                  disabled: _ctx.loading,
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
                }, [
                  _withDirectives(_createElementVNode("span", null, [
                    _createElementVNode("span", _hoisted_11, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                    ]),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("common.apply")), 1)
                  ], 512), [
                    [_vShow, !_ctx.loading]
                  ]),
                  _withDirectives(_createElementVNode("span", null, [
                    _hoisted_12,
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("common.pleaseWait")), 1)
                  ], 512), [
                    [_vShow, _ctx.loading]
                  ])
                ], 8, _hoisted_10)), [
                  [_directive_auth, { auth: ['update'] }]
                ])
              ])
            ])),
        _createElementVNode("div", _hoisted_13, [
          (_ctx.type === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createVNode(_component_TemplateType, {
                          type: _ctx.formData.type
                        }, {
                          individual: _withCtx(() => [
                            _hoisted_19
                          ]),
                          company: _withCtx(() => [
                            _hoisted_20
                          ]),
                          _: 1
                        }, 8, ["type"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.formData.name), 1),
                            _createElementVNode("span", {
                              class: _normalizeClass(["badge text-uppercase", 
                          _ctx.getSettlementEntityStatus(Number(_ctx.formData.status))
                        ])
                            }, _toDisplayString(_ctx.formData.__show.status), 3)
                          ]),
                          _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.formData.custom_name), 1)
                        ])
                      ])
                    ])
                  ]),
                  _createVNode(_component_TemplateType, {
                    type: _ctx.formData.type
                  }, {
                    individual: _withCtx(() => [
                      (_ctx.formData.mobile_number || _ctx.formData.passport_number)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                            _createElementVNode("div", _hoisted_28, [
                              _createElementVNode("div", _hoisted_29, [
                                (_ctx.formData.mobile_number)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                      _createElementVNode("div", _hoisted_31, [
                                        _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.formData.mobile_area_code +
                              " " +
                              _ctx.formData.mobile_number), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.$t("settlementEntity.mobileNo")), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.formData.passport_number)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                      _createElementVNode("div", _hoisted_35, [
                                        _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.formData.passport_number), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.$t("settlementEntity.passportNo")), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    company: _withCtx(() => [
                      (_ctx.formData.vat_number || _ctx.formData.tax_number)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                            _createElementVNode("div", _hoisted_39, [
                              _createElementVNode("div", _hoisted_40, [
                                (_ctx.formData.vat_number)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                      _createElementVNode("div", _hoisted_42, [
                                        _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.formData.vat_number), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.$t("settlementEntity.vatNo")), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.formData.tax_number)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                      _createElementVNode("div", _hoisted_46, [
                                        _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.formData.tax_number), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.$t("settlementEntity.taxNo")), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.formData.telephone)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                      _createElementVNode("div", _hoisted_50, [
                                        _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.formData.telephone), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.$t("settlementEntity.telephone")), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["type"])
                ])), [
                  [_directive_loading, _ctx.loading]
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.type === 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_54, [
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("div", _hoisted_56, [
                      _createElementVNode("div", _hoisted_57, [
                        _createElementVNode("label", _hoisted_58, _toDisplayString(_ctx.$t("settlementEntity.name")), 1),
                        _createVNode(_component_el_form_item, { prop: "name" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.formData.name,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.name) = $event)),
                              type: "text",
                              placeholder: _ctx.$t('common.plsEnter'),
                              clearable: ""
                            }, null, 8, ["modelValue", "placeholder"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_59, [
                      _createElementVNode("div", _hoisted_60, [
                        _createElementVNode("label", _hoisted_61, _toDisplayString(_ctx.$t("settlementEntity.customName")), 1),
                        _createVNode(_component_el_form_item, { prop: "custom_name" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.formData.custom_name,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.custom_name) = $event)),
                              type: "text",
                              placeholder: _ctx.$t('common.plsEnter'),
                              clearable: ""
                            }, null, 8, ["modelValue", "placeholder"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_62, [
                      _createElementVNode("div", _hoisted_63, [
                        _createElementVNode("label", _hoisted_64, _toDisplayString(_ctx.$t("settlementEntity.status")), 1),
                        _createVNode(_component_el_form_item, { prop: "status" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              class: "w-100",
                              modelValue: _ctx.formData.status,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.status) = $event)),
                              clearable: "",
                              filterable: "",
                              disabled: 
                        !_ctx.checkPermissionFlag({ auth: ['modify_status'] })
                      ,
                              placeholder: _ctx.$t('common.plsSelect')
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.statusOptions, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.value,
                                    label: item.label,
                                    value: item.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "disabled", "placeholder"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createVNode(_component_TemplateType, {
                      type: _ctx.formData.type
                    }, {
                      individual: _withCtx(() => [
                        _hoisted_65,
                        _createElementVNode("div", _hoisted_66, [
                          _createElementVNode("div", _hoisted_67, [
                            _createElementVNode("label", _hoisted_68, _toDisplayString(_ctx.$t("settlementEntity.mobileNo")), 1),
                            _createVNode(_component_el_form_item, { prop: "mobile_number" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_69, [
                                  _createElementVNode("div", _hoisted_70, [
                                    _createVNode(_component_el_select, {
                                      class: "w-100px size-sm",
                                      modelValue: _ctx.formData.mobile_area_code,
                                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.mobile_area_code) = $event)),
                                      autocomplete: "off",
                                      placeholder: " "
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.phoneCode, (row) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: row.label,
                                            label: row.label,
                                            value: row.label
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _createVNode(_component_el_input, {
                                    class: "w-100 text-start",
                                    modelValue: _ctx.formData.mobile_number,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.mobile_number) = $event)),
                                    type: "text",
                                    placeholder: _ctx.$t('common.plsEnter'),
                                    clearable: ""
                                  }, null, 8, ["modelValue", "placeholder"])
                                ])
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_71, [
                          _createElementVNode("div", _hoisted_72, [
                            _createElementVNode("label", _hoisted_73, _toDisplayString(_ctx.$t("settlementEntity.passportNo")), 1),
                            _createVNode(_component_el_form_item, { prop: "passport_number" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.formData.passport_number,
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.passport_number) = $event)),
                                  type: "text",
                                  placeholder: _ctx.$t('common.plsEnter'),
                                  clearable: ""
                                }, null, 8, ["modelValue", "placeholder"])
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ]),
                      company: _withCtx(() => [
                        _createElementVNode("div", _hoisted_74, [
                          _createElementVNode("div", _hoisted_75, [
                            _createElementVNode("label", _hoisted_76, _toDisplayString(_ctx.$t("settlementEntity.vatNo")), 1),
                            _createVNode(_component_el_form_item, { prop: "vat_number" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.formData.vat_number,
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.vat_number) = $event)),
                                  type: "text",
                                  placeholder: _ctx.$t('common.plsEnter'),
                                  clearable: ""
                                }, null, 8, ["modelValue", "placeholder"])
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_77, [
                          _createElementVNode("div", _hoisted_78, [
                            _createElementVNode("label", _hoisted_79, _toDisplayString(_ctx.$t("settlementEntity.taxNo")), 1),
                            _createVNode(_component_el_form_item, { prop: "tax_number" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.formData.tax_number,
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.tax_number) = $event)),
                                  type: "text",
                                  placeholder: _ctx.$t('common.plsEnter'),
                                  clearable: ""
                                }, null, 8, ["modelValue", "placeholder"])
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_80, [
                          _createElementVNode("div", _hoisted_81, [
                            _createElementVNode("label", _hoisted_82, _toDisplayString(_ctx.$t("settlementEntity.telephone")), 1),
                            _createVNode(_component_el_form_item, { prop: "telephone" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.formData.telephone,
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.telephone) = $event)),
                                  type: "text",
                                  placeholder: _ctx.$t('common.plsEnter'),
                                  clearable: ""
                                }, null, 8, ["modelValue", "placeholder"])
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["type"])
                  ])
                ])), [
                  [_directive_loading, _ctx.loading]
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_83, [
            _createElementVNode("div", _hoisted_84, [
              _createElementVNode("div", _hoisted_85, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.$t("common.information")), 1)
              ])
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_86, [
              (_ctx.type === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                    _createElementVNode("div", _hoisted_88, [
                      _createElementVNode("div", _hoisted_89, [
                        _createElementVNode("label", _hoisted_90, _toDisplayString(_ctx.$t("order.currency")) + ":", 1),
                        _createElementVNode("div", _hoisted_91, [
                          _createElementVNode("span", _hoisted_92, _toDisplayString(_ctx.formData.currency ? _ctx.formData.currency : "--"), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_93, [
                      _createElementVNode("div", _hoisted_94, [
                        _createElementVNode("label", _hoisted_95, _toDisplayString(_ctx.$t("settlementEntity.email")) + ":", 1),
                        _createElementVNode("div", _hoisted_96, [
                          _createElementVNode("span", _hoisted_97, _toDisplayString(_ctx.formData.email ? _ctx.formData.email : "--"), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_98, [
                      _createElementVNode("div", _hoisted_99, [
                        _createElementVNode("label", _hoisted_100, _toDisplayString(_ctx.$t("settlementEntity.zipCode")) + ":", 1),
                        _createElementVNode("div", _hoisted_101, [
                          _createElementVNode("span", _hoisted_102, _toDisplayString(_ctx.formData.postcode ? _ctx.formData.postcode : "--"), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_103, [
                      _createElementVNode("div", _hoisted_104, [
                        _createElementVNode("label", _hoisted_105, _toDisplayString(_ctx.$t("settlementEntity.country")) + ":", 1),
                        _createElementVNode("div", _hoisted_106, [
                          _createElementVNode("span", _hoisted_107, _toDisplayString(_ctx.formData.__show.country_iso_2
                        ? _ctx.formData.__show.country_iso_2
                        : "--"), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_108, [
                      _createElementVNode("div", _hoisted_109, [
                        _createElementVNode("label", _hoisted_110, _toDisplayString(_ctx.$t("settlementEntity.city")) + ":", 1),
                        _createElementVNode("div", _hoisted_111, [
                          _createElementVNode("span", _hoisted_112, _toDisplayString(_ctx.formData.city ? _ctx.formData.city : "--"), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_113, [
                      _createElementVNode("div", _hoisted_114, [
                        _createElementVNode("label", _hoisted_115, _toDisplayString(_ctx.$t("settlementEntity.address")) + ":", 1),
                        _createElementVNode("div", _hoisted_116, [
                          _createElementVNode("span", _hoisted_117, _toDisplayString(_ctx.formData.street ? _ctx.formData.street : "--"), 1)
                        ])
                      ])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_118, [
                    _createElementVNode("div", _hoisted_119, [
                      _createElementVNode("div", _hoisted_120, [
                        _createElementVNode("label", _hoisted_121, _toDisplayString(_ctx.$t("order.currency")), 1),
                        _createVNode(_component_el_form_item, { prop: "currency" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              class: "w-100",
                              modelValue: _ctx.formData.currency,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.currency) = $event)),
                              placeholder: _ctx.$t('common.plsSelect'),
                              clearable: ""
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.currency, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.value,
                                    label: item.label,
                                    value: item.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "placeholder"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_122, [
                      _createElementVNode("div", _hoisted_123, [
                        _createElementVNode("label", _hoisted_124, _toDisplayString(_ctx.$t("settlementEntity.email")), 1),
                        _createVNode(_component_el_form_item, { prop: "email" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.formData.email,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.email) = $event)),
                              type: "text",
                              placeholder: _ctx.$t('common.plsEnter'),
                              clearable: ""
                            }, null, 8, ["modelValue", "placeholder"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_125, [
                      _createElementVNode("div", _hoisted_126, [
                        _createElementVNode("label", _hoisted_127, _toDisplayString(_ctx.$t("settlementEntity.zipCode")), 1),
                        _createVNode(_component_el_form_item, { prop: "postcode" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.formData.postcode,
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.postcode) = $event)),
                              type: "text",
                              placeholder: _ctx.$t('common.plsEnter'),
                              clearable: ""
                            }, null, 8, ["modelValue", "placeholder"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_128, [
                      _createElementVNode("div", _hoisted_129, [
                        _createElementVNode("label", _hoisted_130, _toDisplayString(_ctx.$t("settlementEntity.country")), 1),
                        _createVNode(_component_el_form_item, {
                          prop: "country_code",
                          onClick: _cache[15] || (_cache[15] = _withModifiers(() => {}, ["stop"]))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              class: "w-100",
                              modelValue: _ctx.formData.country_code,
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.country_code) = $event)),
                              clearable: "",
                              filterable: "",
                              placeholder: _ctx.$t('common.plsSelect'),
                              onChange: _ctx.countryChange
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.country, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.value,
                                    label: item.label,
                                    value: item.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "placeholder", "onChange"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_131, [
                      _createElementVNode("div", _hoisted_132, [
                        _createElementVNode("label", _hoisted_133, _toDisplayString(_ctx.$t("settlementEntity.city")), 1),
                        _createVNode(_component_el_form_item, { prop: "city" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_autocomplete, {
                              class: "w-100",
                              clearable: "",
                              modelValue: _ctx.formData.city,
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formData.city) = $event)),
                              disabled: !_ctx.formData.country_code,
                              "fetch-suggestions": _ctx.querySearchAsync,
                              placeholder: _ctx.$t('common.plsEnter')
                            }, null, 8, ["modelValue", "disabled", "fetch-suggestions", "placeholder"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_134, [
                      _createElementVNode("div", _hoisted_135, [
                        _createElementVNode("label", _hoisted_136, _toDisplayString(_ctx.$t("settlementEntity.address")), 1),
                        _createVNode(_component_el_form_item, { prop: "street" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.formData.street,
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formData.street) = $event)),
                              type: "textarea",
                              placeholder: _ctx.$t('common.plsEnter'),
                              clearable: ""
                            }, null, 8, ["modelValue", "placeholder"])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]))
            ])), [
              [_directive_loading, _ctx.loading]
            ])
          ]),
          _createElementVNode("div", _hoisted_137, [
            _createElementVNode("div", _hoisted_138, [
              _createElementVNode("div", _hoisted_139, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.$t("settlementEntity.settlementAccount")), 1)
              ])
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_140, [
              (_ctx.type === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_141, [
                    _createElementVNode("div", _hoisted_142, [
                      _createElementVNode("div", _hoisted_143, [
                        _createElementVNode("label", _hoisted_144, _toDisplayString(_ctx.$t("settlementEntity.bankName")) + ":", 1),
                        _createElementVNode("div", _hoisted_145, [
                          _createElementVNode("span", _hoisted_146, _toDisplayString(_ctx.formData.bank_name ? _ctx.formData.bank_name : "--"), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_147, [
                      _createElementVNode("div", _hoisted_148, [
                        _createElementVNode("label", _hoisted_149, _toDisplayString(_ctx.$t("settlementEntity.bankAccountName")) + ":", 1),
                        _createElementVNode("div", _hoisted_150, [
                          _createElementVNode("span", _hoisted_151, _toDisplayString(_ctx.formData.bank_account_name
                        ? _ctx.formData.bank_account_name
                        : "--"), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_152, [
                      _createElementVNode("div", _hoisted_153, [
                        _createElementVNode("label", _hoisted_154, _toDisplayString(_ctx.$t("settlementEntity.iban")) + ":", 1),
                        _createElementVNode("div", _hoisted_155, [
                          _createElementVNode("span", _hoisted_156, _toDisplayString(_ctx.formData.iban ? _ctx.formData.iban : "--"), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_157, [
                      _createElementVNode("div", _hoisted_158, [
                        _createElementVNode("label", _hoisted_159, _toDisplayString(_ctx.$t("settlementEntity.bankAccountNo")) + ":", 1),
                        _createElementVNode("div", _hoisted_160, [
                          _createElementVNode("span", _hoisted_161, _toDisplayString(_ctx.formData.bank_account_number
                        ? _ctx.formData.bank_account_number
                        : "--"), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_162, [
                      _createElementVNode("div", _hoisted_163, [
                        _createElementVNode("label", _hoisted_164, _toDisplayString(_ctx.$t("settlementEntity.bic")) + ":", 1),
                        _createElementVNode("div", _hoisted_165, [
                          _createElementVNode("span", _hoisted_166, _toDisplayString(_ctx.formData.bic ? _ctx.formData.bic : "--"), 1)
                        ])
                      ])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_167, [
                    _createElementVNode("div", _hoisted_168, [
                      _createElementVNode("div", _hoisted_169, [
                        _createElementVNode("label", _hoisted_170, _toDisplayString(_ctx.$t("settlementEntity.bankName")), 1),
                        _createVNode(_component_el_form_item, { prop: "bank_name" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.formData.bank_name,
                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formData.bank_name) = $event)),
                              type: "text",
                              placeholder: _ctx.$t('common.plsEnter'),
                              clearable: ""
                            }, null, 8, ["modelValue", "placeholder"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_171, [
                      _createElementVNode("div", _hoisted_172, [
                        _createElementVNode("label", _hoisted_173, _toDisplayString(_ctx.$t("settlementEntity.bankAccountName")), 1),
                        _createVNode(_component_el_form_item, { prop: "bank_account_name" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.formData.bank_account_name,
                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.formData.bank_account_name) = $event)),
                              type: "text",
                              placeholder: _ctx.$t('common.plsEnter'),
                              clearable: ""
                            }, null, 8, ["modelValue", "placeholder"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_174, [
                      _createElementVNode("div", _hoisted_175, [
                        _createElementVNode("label", _hoisted_176, _toDisplayString(_ctx.$t("settlementEntity.bankAccountNo")), 1),
                        _createVNode(_component_el_form_item, { prop: "bank_account_number" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.formData.bank_account_number,
                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.formData.bank_account_number) = $event)),
                              type: "text",
                              placeholder: _ctx.$t('common.plsEnter'),
                              clearable: ""
                            }, null, 8, ["modelValue", "placeholder"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_177, [
                      _createElementVNode("div", _hoisted_178, [
                        _createElementVNode("label", _hoisted_179, _toDisplayString(_ctx.$t("settlementEntity.iban")), 1),
                        _createVNode(_component_el_form_item, { prop: "iban" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.formData.iban,
                              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.formData.iban) = $event)),
                              type: "text",
                              placeholder: _ctx.$t('common.plsEnter'),
                              clearable: ""
                            }, null, 8, ["modelValue", "placeholder"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_180, [
                      _createElementVNode("div", _hoisted_181, [
                        _createElementVNode("label", _hoisted_182, _toDisplayString(_ctx.$t("settlementEntity.bic")), 1),
                        _createVNode(_component_el_form_item, { prop: "bic" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.formData.bic,
                              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.formData.bic) = $event)),
                              type: "text",
                              placeholder: _ctx.$t('common.plsEnter'),
                              clearable: ""
                            }, null, 8, ["modelValue", "placeholder"])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]))
            ])), [
              [_directive_loading, _ctx.loading]
            ])
          ]),
          _createVNode(_component_TemplateType, {
            type: _ctx.formData.type
          }, {
            company: _withCtx(() => [
              _createElementVNode("div", _hoisted_183, [
                _createElementVNode("div", _hoisted_184, [
                  _createElementVNode("div", _hoisted_185, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.$t("settlementEntity.additionalData")), 1)
                  ])
                ]),
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_186, [
                  (_ctx.type === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_187, [
                        _createElementVNode("div", _hoisted_188, [
                          _createElementVNode("div", _hoisted_189, [
                            _createElementVNode("label", _hoisted_190, _toDisplayString(_ctx.$t("settlementEntity.insolvent")) + ":", 1),
                            _createElementVNode("div", _hoisted_191, [
                              _createElementVNode("span", _hoisted_192, _toDisplayString(_ctx.formData.insolvent === 1
                            ? _ctx.$t("common.yes")
                            : _ctx.$t("common.no")), 1)
                            ])
                          ])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_193, [
                        _createElementVNode("div", _hoisted_194, [
                          _createElementVNode("div", _hoisted_195, [
                            _createElementVNode("label", _hoisted_196, _toDisplayString(_ctx.$t("settlementEntity.insolvent")), 1),
                            _createVNode(_component_el_form_item, {
                              prop: "insolvent",
                              onClick: _cache[24] || (_cache[24] = _withModifiers(() => {}, ["stop"]))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_select, {
                                  class: "w-100",
                                  modelValue: _ctx.formData.insolvent,
                                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.formData.insolvent) = $event)),
                                  placeholder: _ctx.$t('common.plsSelect')
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_option, {
                                      label: _ctx.$t('common.yes'),
                                      value: 1
                                    }, null, 8, ["label"]),
                                    _createVNode(_component_el_option, {
                                      label: _ctx.$t('common.no'),
                                      value: 0
                                    }, null, 8, ["label"])
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "placeholder"])
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ]))
                ])), [
                  [_directive_loading, _ctx.loading]
                ])
              ])
            ]),
            _: 1
          }, 8, ["type"]),
          (_ctx.type === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_197, [
                _createElementVNode("div", _hoisted_198, [
                  _createElementVNode("div", _hoisted_199, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.$t("common.historyLog")), 1)
                  ])
                ]),
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_200, [
                  _createElementVNode("div", _hoisted_201, [
                    _createElementVNode("div", _hoisted_202, [
                      _createElementVNode("div", _hoisted_203, [
                        _createElementVNode("label", _hoisted_204, _toDisplayString(_ctx.$t("common.creator")) + ":", 1),
                        _createElementVNode("div", _hoisted_205, [
                          _createElementVNode("span", _hoisted_206, _toDisplayString(_ctx.formData.__show.created_name
                        ? _ctx.formData.__show.created_name
                        : "--"), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_207, [
                      _createElementVNode("div", _hoisted_208, [
                        _createElementVNode("label", _hoisted_209, _toDisplayString(_ctx.$t("common.creationDate")) + ":", 1),
                        _createElementVNode("div", _hoisted_210, [
                          _createElementVNode("span", _hoisted_211, _toDisplayString(_ctx.formData.created_at
                        ? _ctx.formatDate(_ctx.formData.created_at, "DD.MM.YYYY HH:mm")
                        : "--"), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_212, [
                      _createElementVNode("div", _hoisted_213, [
                        _createElementVNode("label", _hoisted_214, _toDisplayString(_ctx.$t("common.lastModifiedBy")) + ":", 1),
                        _createElementVNode("div", _hoisted_215, [
                          _createElementVNode("span", _hoisted_216, _toDisplayString(_ctx.formData.__show.updated_name
                        ? _ctx.formData.__show.updated_name
                        : "--"), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_217, [
                      _createElementVNode("div", _hoisted_218, [
                        _createElementVNode("label", _hoisted_219, _toDisplayString(_ctx.$t("common.lastModifiedDate")) + ":", 1),
                        _createElementVNode("div", _hoisted_220, [
                          _createElementVNode("span", _hoisted_221, _toDisplayString(_ctx.formData.updated_at
                        ? _ctx.formatDate(_ctx.formData.updated_at, "DD.MM.YYYY HH:mm")
                        : "--"), 1)
                        ])
                      ])
                    ])
                  ])
                ])), [
                  [_directive_loading, _ctx.loading]
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.type === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_222, [
              _createVNode(_component_router_link, {
                class: "btn bg-secondary align-self-center text-gray-600",
                replace: "",
                to: _ctx.goPath(1)
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_223, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr063.svg" })
                  ]),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("settlementEntity.return")), 1)
                ]),
                _: 1
              }, 8, ["to"]),
              _createElementVNode("div", _hoisted_224, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn bg-secondary align-self-center text-gray-600",
                  disabled: _ctx.loading,
                  onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.getShowInfo && _ctx.getShowInfo(...args)))
                }, [
                  _withDirectives(_createElementVNode("span", null, [
                    _createElementVNode("span", _hoisted_226, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr059.svg" })
                    ]),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("common.reset")), 1)
                  ], 512), [
                    [_vShow, !_ctx.loading]
                  ]),
                  _withDirectives(_createElementVNode("span", null, [
                    _hoisted_227,
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("common.pleaseWait")), 1)
                  ], 512), [
                    [_vShow, _ctx.loading]
                  ])
                ], 8, _hoisted_225),
                _withDirectives((_openBlock(), _createElementBlock("button", {
                  type: "button",
                  class: "btn btn-primary",
                  disabled: _ctx.loading,
                  onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
                }, [
                  _withDirectives(_createElementVNode("span", null, [
                    _createElementVNode("span", _hoisted_229, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                    ]),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("common.apply")), 1)
                  ], 512), [
                    [_vShow, !_ctx.loading]
                  ]),
                  _withDirectives(_createElementVNode("span", null, [
                    _hoisted_230,
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("common.pleaseWait")), 1)
                  ], 512), [
                    [_vShow, _ctx.loading]
                  ])
                ], 8, _hoisted_228)), [
                  [_directive_auth, { auth: ['update'] }]
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["model", "rules"])
  ]))
}